import React from 'react';
import { SaladTable, ViewFieldType } from 'saladsoft-primitive';
import { AdminVoucherDto } from 'services/data-contracts';

const VoucherView = ({ voucher }: { voucher: AdminVoucherDto }) => {
  const priceConverter = (voucher: AdminVoucherDto) => {
    return voucher.price ? `${voucher.price.toLocaleString()} ${voucher.discountType === 'PERCENT' ? '%' : '원'}` : '';
  };

  const fields: ViewFieldType<AdminVoucherDto>[] = [
    {
      key: 'code' as const,
      path: 'code',
      label: '바우처 코드',
      controlType: 'text',
    },
    {
      key: 'category' as const,
      label: '카테고리',
      controlType: 'custom',
      template: <div>{voucher.category?.name || ''}</div>,
    },
    {
      key: 'discountType' as const,
      label: '할인 타입',
      controlType: 'custom',
      template: <div>{voucher.discountType === 'PERCENT' ? '비율할인' : '정액할인'}</div>,
    },
    {
      key: 'price' as const,
      label: '금액',
      controlType: 'custom',
      template: <div>{priceConverter(voucher)}</div>,
    },
    {
      key: 'status' as const,
      path: 'status',
      label: '상태',
      controlType: 'text',
    },
    {
      key: 'stayStartDate' as const,
      path: 'stayStartDate',
      label: '숙박 시작일',
    },
    {
      key: 'stayEndDate' as const,
      path: 'stayEndDate',
      label: '숙박 종료일',
    },
    {
      key: 'expireDate' as const,
      path: 'expireDate',
      label: '만료일',
      controlType: 'datetime',
    },
    {
      key: 'createDate' as const,
      path: 'createDate',
      label: '생성일',
      controlType: 'datetime',
    },
    {
      key: 'creator' as const,
      label: '작성자',
      controlType: 'custom',
      template: <div>{voucher.creator?.username || ''}</div>,
    },
    {
      key: 'remark' as const,
      label: '비고',
      controlType: 'text',
    },
  ];

  return (
    <div style={{ paddingBottom: 40 }}>
      <SaladTable.SaladView fields={fields as any} values={voucher} />
    </div>
  );
};

export default VoucherView;
